import React from 'react';

import { Promotion, PromotionStatus } from './types';
import { Badge } from '../component/Badge';
import { ChangePromotionStatus } from '../component/ChangePromotionStatus';
import { PromotionPageShell } from '../component/Promotions/PromotionPageShell';
import { PromotionSectionCard } from '../component/Promotions/PromotionSectionCard';
import { TextInput } from '../component/TextInput';

export const ViewReactivationPromotion = ({
  promotionData,
  onRefresh,
}: {
  promotionData: Promotion;
  onRefresh: () => void;
}) => {
  const subscriptionOrderNumber =
    promotionData.subscription_order_number !== null &&
    promotionData.subscription_order_number !== undefined
      ? promotionData.subscription_order_number.toString()
      : '';

  return (
    <PromotionPageShell
      title="View Plan Reactivation Promotion"
      description="This promotion will apply to plan reactivations only. When this promotion is active, the free product(s) will be displayed in the Review and Confirm page for the plan the customer is reactivating, as well as a free gift indicator in the order cards on the Home tab."
    >
      <PromotionSectionCard>
        <div className="text-md text-left">
          <div className="w-full mb-2">
            <h2>Promotion name</h2>
            <TextInput placeholder="None" value={promotionData?.name} disabled />
          </div>
        </div>

        <div className="w-full mb-2">
          <div className="flex flex-row justify-between">
            <div className="flex-1 mr-4">
              <h2>Status</h2>
              <div className="flex">
                {promotionData && (
                  <ChangePromotionStatus
                    isActive={promotionData?.status === PromotionStatus.ACTIVE}
                    id={promotionData.id}
                    name={promotionData.name}
                    reFetch={onRefresh}
                  />
                )}
              </div>
            </div>
            <div className="flex-1">
              <h2>Creator</h2>
              <Badge label={promotionData?.created_by ?? 'n/a'} />
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="mb-2 mr-2 flex-1">
            <h2 className="mb-2">Currency</h2>
            <TextInput placeholder="None" value={promotionData?.currency} disabled />
          </div>
          <div className="mb-2 mr-2 flex-1">
            <h2 className="mb-2">Eligible country</h2>
            <TextInput placeholder="None" value={promotionData?.eligible_country} disabled />
          </div>
        </div>
      </PromotionSectionCard>

      <PromotionSectionCard>
        <h2>Subscription order eligible for promotional product</h2>
        <p className="text-xs text-gray-500 font-normal mb-2">
          Specify which subscription order will be eligible for the promotional product. This
          counter is for subscription orders, so do not include the customer’s trial order in this
          field.
        </p>

        <div className="flex justify-between items-center space-x-4">
          <div className="w-1/4">
            <TextInput placeholder="None" value={subscriptionOrderNumber} disabled />
          </div>
          <div className="w-3/4">
            <p>subscription order</p>
          </div>
        </div>
      </PromotionSectionCard>

      <PromotionSectionCard>
        <div className="w-full mb-2">
          <h2>Free promotional product(s)</h2>
          <div className="flex justify-between space-x-4">
            <div className="w-3/4">
              <TextInput placeholder="None" value={promotionData?.free_product_code} disabled />
            </div>
            <div className="w-1/4">
              <TextInput
                placeholder="None"
                value={promotionData?.quantity ? promotionData.quantity.toString() : ''}
                disabled
              />
            </div>
          </div>
        </div>
      </PromotionSectionCard>

      <PromotionSectionCard>
        <h2>
          Toast Message <span className="text-xs">(Optional)</span>
        </h2>
        <p className="text-xs text-gray-500 font-normal mb-2">
          Customer-facing message to be displayed upon each successful login into the customer
          portal when they have a free promotional product on an upcoming order.
        </p>

        <div className="w-full mb-2">
          <h3 className="flex">Title Text</h3>
          <TextInput placeholder="None" value={promotionData?.toast_title_copy ?? ''} disabled />
        </div>

        <div className="w-full mb-2">
          <h3 className="flex">Body Text</h3>
          <TextInput placeholder="None" value={promotionData?.toast_body_copy ?? ''} disabled />
        </div>
      </PromotionSectionCard>
    </PromotionPageShell>
  );
};
